import { Box, Button, Dialog, Typography } from '@material-ui/core';
import { ErrorOutlineOutlined } from '@material-ui/icons';
import React from 'react';
import { colors } from './theme';

export interface ConfirmModalProps {
  open: boolean;
  title: string;
  subTitle?: string;
  confirmText?: string;
  icon?: React.ElementType;
  handleConfirm: () => void;
  handleCancel?: () => void;
  showCancel?: boolean;
  iconColor?: string;
  justifyContentButton?: string;
}

export const ConfirmModal = ({
  open,
  title,
  subTitle,
  confirmText = 'Yes',
  handleConfirm,
  handleCancel,
  icon: Icon = ErrorOutlineOutlined,
  showCancel = true,
  iconColor = colors.warning.main,
  justifyContentButton = 'center'
}: ConfirmModalProps) => {
  const [requesting, setRequesting] = React.useState<boolean>(false);
  const handleClickConfirm = async () => {
    setRequesting(true);
    await handleConfirm();
    setRequesting(false);
  };

  return (
    <Dialog open={open} maxWidth='sm'>
      <Box height='100%' p={6} width={500} textAlign='center'>
        <Box width='100%' height='100%' display='flex' justifyContent='center' pt={1} pb={3}>
          <Icon style={{ color: iconColor }} className='extra-large' />
        </Box>

        <Typography variant='h5'>
          <div dangerouslySetInnerHTML={{ __html: title }} />
        </Typography>
        {subTitle && (
          <Box mt={2}>
            <Typography variant='subtitle2'>
              <div dangerouslySetInnerHTML={{ __html: subTitle }} />
            </Typography>
          </Box>
        )}
        <Box width='100%' display='flex' justifyContent={justifyContentButton} alignItems='center' pt={4}>
          <Button
            disabled={requesting}
            color='primary'
            variant='contained'
            onClick={handleClickConfirm}
            className='swyft-action small-button'
          >
            {confirmText}
          </Button>
          {showCancel && (
            <Box ml={2}>
              <Button color='secondary' variant='outlined' onClick={handleCancel} className='swyft-action small-button'>
                Cancel
              </Button>
            </Box>
          )}
        </Box>
      </Box>
    </Dialog>
  );
};
